// Core packages
import { NgModule } from '@angular/core';

// Third party packages

// Custom packages - Modules
import { PersonalDataRoutingModule } from './personal-data-routing.module';
// import { PublicModule } from 'src/app/modules/public/public.module';
import { SharedModule } from '../shared.module';

// Custom packages - Components
import { PersonalDataListComponent } from 'src/app/modules/personal-data/pages/personal-data-list/personal-data-list.page';

@NgModule({
  imports: [
    // Shared modules
    SharedModule,

    // Custom
    PersonalDataRoutingModule,
    // PublicModule,
  ],
  declarations: [
    PersonalDataListComponent,
  ],
  entryComponents: [
  ],
  exports: [
  ]
})
export class PersonalDataModule { }
